function isProgramType(type) {
    return (p) => {
        return p.type === type;
    };
}
export const isContentProgram = isProgramType('content');
export const isFlexProgram = isProgramType('flex');
export const isRedirectProgram = isProgramType('redirect');
export const isCustomProgram = isProgramType('custom');
export const isFillerProgram = isProgramType('filler');
export function programUniqueId(program) {
    if (isContentProgram(program)) {
        return program.uniqueId;
    }
    else if (isFlexProgram(program)) {
        return 'flex'; // Cannot really be unique identified
    }
    else if (isRedirectProgram(program)) {
        return `redirect.${program.channel}`;
    }
    else if (isCustomProgram(program)) {
        return `custom.${program.customShowId}.${program.id}`;
    }
    else if (isFillerProgram(program)) {
        return `filler.${program.fillerListId}.${program.id}`;
    }
    return null;
}
//# sourceMappingURL=Program.js.map